import * as dayjs from 'dayjs';

export function dateFormat(date) {
  return dayjs(date).format('YYYY/MM/DD');
}
